import Vuex from 'vuex'
import Vue from 'vue'
import mj_axios from '@/mj_axios.js';
import VueCookies from 'vue-cookies'

Vue.use(Vuex, VueCookies)

const store = new Vuex.Store({
    state: {
        packageVersion: process.env.PACKAGE_VERSION || '0', //presa da package.json grazie ad una configurazione su vue.config.js
        client_settings: {},
        token_obj: window.$cookies.get("token_obj") || '',
        modal: { title: 'Attenzione', text: 'Qualcosa è andato storto', visible: false },
        user: {},
        studio:(window.localStorage.getItem("studio") != null && window.localStorage.getItem("studio").length > 0) ? JSON.parse(window.localStorage.getItem("studio")) : {}, //di default lo prendo dal local storage in modo che resista al refresh della pagina
        modal_navigation_breadcumbs: [] //memorizziamo le rotte con meta.header == close, quelle che simulano un modal
    },
    mutations: {
        updateLastModalNavigationBreacumbs(state,route){
            Vue.set(state.modal_navigation_breadcumbs, this.state.modal_navigation_breadcumbs.length-1, route)
        },
        pushToModalNavigationBreadcumbs(state, route) {
            // state.modal_navigation_breadcumbs.push(route);

            Vue.set(state.modal_navigation_breadcumbs, this.state.modal_navigation_breadcumbs.length, route)
        },
        popToModalNavigationBreadcumbs(state) {
            //cancelliamo l'ultimo
            state.modal_navigation_breadcumbs.splice(this.state.modal_navigation_breadcumbs.length - 1, 1);
        },
        doublePopToModalNavigationBreadcumbs(state) {
            //cancelliamo l'ultimo e il penultimo
            //il penultimo perchè la navigation guard su router.js lo re-inserirà dopo il caricamento della rotta
            state.modal_navigation_breadcumbs.splice(this.state.modal_navigation_breadcumbs.length - 2, 2);
        },
        resetModalNavigationBreadcumbs(state) {
            state.modal_navigation_breadcumbs = [];
        },
        updateClientVar(state, client_settings) {
            this.state.client_settings = client_settings;
            document.title = client_settings.APPNAME;
        },
        login_success(state, token_obj) {
            window.$cookies.set("token_obj", token_obj); //support json object
            mj_axios.defaults.headers.common['Authorization'] = `Bearer ${token_obj.access_token}`;
            state.token_obj = token_obj
        },
        login_fail() {

        },
        logout(state) {
            state.token_obj = '';
            state.studio = {};

        },
        update_studio_data(state,studio){
            state.studio = studio;
        },
        update_modal_dialog(state, modal_obj) {
            state.modal = modal_obj;

        }
    },
    actions: {

        //ottengo le client var
        fetchClientVar(context) {
            mj_axios
                .get("/api/var/client_var")
                .then(response => {
                    const client_settings = response.data;
                    mj_axios.defaults.baseURL = client_settings.SERVER_BASEURL
                    context.commit('updateClientVar', client_settings);
                })
                .catch(response => {
                    alert("error in get client setting " + response);
                });
        },
        //operazione di login
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                mj_axios({ url: "/api/user/login", data: user, method: 'POST' })
                    .then(resp => {
                        const token_obj = resp.data;
                        commit('login_success', token_obj);
                        resolve(resp);
                    })
                    .catch(err => {
                        window.$cookies.remove("token_obj");
                        reject(err);
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                mj_axios
                    .get("/api/user/logout")
                    .then(() => {

                    })
                    .catch(response => {
                        alert("error logout " + response);
                    })
                    .then(() => {
                        commit('logout')
                        window.$cookies.remove("token_obj");
                        window.localStorage.setItem("studio", '');
                        delete mj_axios.defaults.headers.common['Authorization'];
                        resolve()
                    });
            })
        },
        loadStudioData({commit},codice_studio){

            let codice_studio_extrapath = '';
            if (codice_studio.length > 0) codice_studio_extrapath = "/"+codice_studio; //aggiungo lo slash solo se ho un codice studio altrimenti laravel si arrabbia
            const axios_promise = mj_axios.get(`/api/studio_public_data${codice_studio_extrapath}`);
            axios_promise.then(response => {
                const studio = response.data.data;
                studio.studio_code = codice_studio;

                //lo memorizzo anche nel localstorage in modo che "resista" anche al refresh (F5 browser) della pagina
                window.localStorage.setItem("studio", JSON.stringify(studio));

                commit('update_studio_data', studio);
            }).catch(() => {
                alert("Errore Caricamento Studio nello store")

            }).then(() => {

            });
            return axios_promise;
        },
    },
    getters: {
        appVersion: (state) => {
            return state.packageVersion
        }
    }

});

export default store;